import { Web3TsConfig } from "../IWeb3Ts";

export const buyContractABI = (config: Web3TsConfig) => [
 {
  inputs: [
   {
    internalType: "address",
    name: "_refer",
    type: "address",
   },
  ],
  name: config.buyContract.buyMethod,
  outputs: [],
  stateMutability: "payable",
  type: "function",
 },
 {
  inputs: [
   {
    internalType: "uint256",
    name: "usdtAmount",
    type: "uint256",
   },
   {
    internalType: "address",
    name: "referralAddress",
    type: "address",
   },
  ],
  name: config.buyContract.buyUSDTMethod,
  outputs: [],
  stateMutability: "nonpayable",
  type: "function",
 },
 {
  inputs: [],
  name: "getBNBUSDTPrice",
  outputs: [
   {
    internalType: "uint256",
    name: "",
    type: "uint256",
   },
  ],
  stateMutability: "view",
  type: "function",
 },
 {
  inputs: [],
  name: "minBuy",
  outputs: [
   {
    internalType: "uint256",
    name: "",
    type: "uint256",
   },
  ],
  stateMutability: "view",
  type: "function",
 },
 {
  inputs: [],
  name: "minBuyUSDT",
  outputs: [
   {
    internalType: "uint256",
    name: "",
    type: "uint256",
   },
  ],
  stateMutability: "view",
  type: "function",
 },
 {
  inputs: [],
  name: "maxBuy",
  outputs: [
   {
    internalType: "uint256",
    name: "",
    type: "uint256",
   },
  ],
  stateMutability: "view",
  type: "function",
 },
 {
  inputs: [],
  name: "maxBuyUSDT",
  outputs: [
   {
    internalType: "uint256",
    name: "",
    type: "uint256",
   },
  ],
  stateMutability: "view",
  type: "function",
 },
 {
  inputs: [],
  name: "isPaused",
  outputs: [
   {
    internalType: "bool",
    name: "",
    type: "bool",
   },
  ],
  stateMutability: "view",
  type: "function",
 },
 {
  inputs: [],
  name: "salePrice",
  outputs: [
   {
    internalType: "uint256",
    name: "",
    type: "uint256",
   },
  ],
  stateMutability: "view",
  type: "function",
 },
 {
  inputs: [],
  name: "salePriceUSDT",
  outputs: [
   {
    internalType: "uint256",
    name: "",
    type: "uint256",
   },
  ],
  stateMutability: "view",
  type: "function",
 },
];
